//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailEntrance from '../common/DetailEntrance';
import DetailEntranceNew from '../common/DetailEntranceNew';
import DetailBlock from './DetailBlock';
import Drip from 'drip';
export default {
  name: 'detail-recommand',
  components: {
    DetailEntrance: DetailEntrance,
    DetailBlock: DetailBlock,
    DetailEntranceNew: DetailEntranceNew
  },
  props: {
    recommandList: {
      type: Array
    },
    isCategory: {
      type: Boolean
    },
    newDetailEntrance: {
      type: Boolean
    },
    successPage: {
      type: Boolean
    },
    titleText: {
      type: String
    }
  },
  data: function data() {
    return {
      title: this.titleText || '为你推荐'
    };
  },
  mounted: function mounted() {},
  methods: {
    clickStatus: function clickStatus(e) {
      try {
        this.$emit('clickStatus', e);
      } catch (e) {
        console.log('clickStatus error', e);
      }
    },
    goToHome: function goToHome() {
      if (Drip.UA.IS_DouyinShowMicroApp) {
        window.tt.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
      } else if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
        window.xhs.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
      } else if (Drip.UA.IS_MAOYAN) {
        Drip.constant.gotoShowHomeTab();
        return;
      } else if (Drip.UA.IS_MAOYAN_BAIDU_APP) {
        window.swan.webView.switchTab({
          url: '/pages/tabshow/index'
        });
      } else {
        Drip.redirect('/myshow/index.html');
      }
    }
  }
};